require('@/config/actionCable')
require('@/config/axios')
require('@/config/auth')
require('@/config/filters')
require('@/config/directives')
require('@/config/fa-icons')
require('@/config/plugins')
require('@/config/global-components')
